
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.502.576c.686.473.947 2.976.947 2.976v1.859l.946.35v-.047a1.37 1.37 0 01-.076-.251v-.747c0-.096.079-.175.175-.175h.355a.194.194 0 01.152.189v.823a.228.228 0 01-.133.222v.128l.908.312v-.047a1.368 1.368 0 01-.075-.251V5.17c0-.096.079-.175.175-.175h.355c.088.02.151.099.151.189v.823a.227.227 0 01-.132.223v.127s2.739.904 2.99.97c.132.017.238.12.26.251v.648l-5.995-.747s-.033 1.097-.099 2.034a25.812 25.812 0 01-.587 3.033l2.451 1.036a.379.379 0 01.279.275l.043.539-3-.251-.061.303H7.46l-.062-.303-2.999.251.042-.539a.382.382 0 01.279-.275l2.451-1.036a26.229 26.229 0 01-.587-3.033c-.061-.946-.099-2.034-.099-2.034L.5 8.226v-.672a.303.303 0 01.26-.25c.251-.071 2.99-.97 2.99-.97v-.128a.226.226 0 01-.132-.222V5.16c0-.09.063-.169.151-.189h.355c.096 0 .175.079.175.175v.748a1.358 1.358 0 01-.075.25v.048l.908-.312v-.128a.229.229 0 01-.133-.223v-.823c0-.09.064-.169.152-.189h.355c.096 0 .175.079.175.175v.748a1.385 1.385 0 01-.076.25v.048l.946-.351V3.528s.28-2.503.947-2.976"}})])
          )
        }
      }
    